// no operation
const noOp = () => {};

export default noOp;
